import { Navigate, Route, useLocation } from 'react-router-dom';

import { SelectOrganisation } from 'pages/SignUp/SelectOrganisation';
import { FaroRoutes } from 'utils/faro';

import { CheckInbox } from './CheckInbox';
import { CreateUser } from './CreateUser';
import { LoadingInstanceAnimation } from './LoadingInstanceAnimation';
import { signUpRoutes } from './routes';

export const SignUp = () => {
  const location = useLocation();

  return (
    <FaroRoutes>
      <Route path={signUpRoutes.relative.createUser} element={<CreateUser />} />
      <Route path={signUpRoutes.relative.checkInbox} element={<CheckInbox />} />
      <Route path={signUpRoutes.relative.selectOrganisation} element={<SelectOrganisation />} />
      <Route path={signUpRoutes.relative.loadingInstance} element={<LoadingInstanceAnimation />} />
      <Route
        index
        element={
          <Navigate
            replace
            to={{
              pathname: signUpRoutes.createUser,
              search: location.search,
            }}
          />
        }
      />
    </FaroRoutes>
  );
};
